<template>
  <common-race-points-card-parts
    class="race-points-radio-card-parts"
    :cardTitle="$tc('RaceListPage.Information.radioPoint')"
    :pointsCardData="pointsCardData"
  >
    <div v-if="pointsCardData.raceRadioData" class="race-points-radio-card-parts__radio">
      <radio-list-item-parts
        :radioData="pointsCardData.raceRadioData"
        @radioPlay="playRadioAudio"
      />
    </div>
  </common-race-points-card-parts>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import CommonRacePointsCardParts from '@/components/RaceListPage/RaceListPane/parts/CommonRacePointsCardParts.vue'
import RadioDataDocument from '@/store/stores/collectionModule/documents/Radio/RadioDataDocument'
import RadioListItemParts from '@/components/RaceVideoPage/RaceVideoRadioPane/parts/RadioListItemParts.vue'
import { RacePointRadioDataType } from '@/store/stores/pageStore/TopPage/TopPageStore'

/**
 * レース一覧画面: レース ポイント ラジオカードコンポーネント
 */
export default defineComponent({
  name: 'RacePointRadioCardParts',
  components: {
    CommonRacePointsCardParts,
    RadioListItemParts,
  },
  props: {
    /**
     * Race Point Radioデータ
     */
    pointsCardData: {
      type: Object as PropType<RacePointRadioDataType>,
      required: true,
    },
  },
  methods: {
    /**
     * 無線 シングル再生
     * 選択したコンポーネント以外の再生状態をOFFにする
     * @event radioPlay
     */
    playRadioAudio(radioData: RadioDataDocument) {
      this.$emit('radioPlay', radioData)
    },
  },
})
</script>

<style lang="scss" scoped>
.race-points-radio-card-parts {
  &__radio {
    width: 100%;
  }
}
</style>

<style lang="scss">
.race-points-radio-card-parts {
  &__radio {
    .radio-list-item-parts {
      flex-wrap: wrap;

      &:first-child {
        margin-top: 0;
      }

      &::before {
        display: none;
      }

      .radio-list-play-button-parts,
      .radio-list-item-parts__video-scene-select {
        height: 48px;
      }

      .radio-list-play-button-parts {
        @media screen and (max-width: 374px) {
          width: 66px;
        }
      }

      .radio-list-item-parts__video-scene-select {
        .name {
          display: block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        &__information {
          width: calc(100% - 44px);
        }

        &__icon {
          display: none;
        }

        @media screen and (max-width: 374px) {
          .name {
            display: none;
          }

          &__img {
            width: 32px;
          }

          &__information {
            width: calc(100% - 44px);
          }
        }
      }
    }
  }
}
</style>
